import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { AppConstants } from "../../app.constants";
import { Observable, of } from "rxjs";
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorHandlerService } from "src/app/core/services/error-handler.service";

@Injectable({
  providedIn: 'root'
})
export class ProductStatusDashboardService {

  constructor(private http: HttpClient, private router: Router, private errorHandlerService: ErrorHandlerService) { }

  getProductStatus(data: any): Observable<any> {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.ALL_PRODUCT_STATUS.PRODUCT_STATUS}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  UpdateProductStatus(data: any): Observable<any> {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.ALL_PRODUCT_STATUS.UPDATE_PRODUCT_STATUS}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  UpdateProductComment(data: any): Observable<any> {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.ALL_PRODUCT_STATUS.UPDATE_PRODUCT_COMMENT}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
}
